import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Phone, Menu, X } from 'lucide-react';
import { Button } from '../ui/button';
import { companyInfo } from '../../mock';
import { scrollToSection } from './scroll';
import { ChristmasTicker } from './ChristmasTicker';
import { SocialLinks } from './SocialLinks';

const NAV_ITEMS = [
  { label: 'Services', section: 'services' },
  { label: 'About', section: 'about' },
  { label: 'Gallery', to: '/gallery' },
  { label: 'Blog', to: '/blog' },
  { label: 'Testimonials', section: 'testimonials' },
  { label: 'Contact', section: 'contact' },
];

const linkClass = 'text-gray-700 hover:text-yellow-500 transition-colors font-medium';

const NavLinks = ({ mobile, onNavigate }) => (
  <>
    {NAV_ITEMS.map((item) => {
      const cls = mobile ? `${linkClass} text-left` : linkClass;
      const testId = `nav-${mobile ? 'mobile-' : ''}${item.label.toLowerCase()}`;
      return item.to ? (
        <Link key={item.label} to={item.to} className={cls} data-testid={testId}>{item.label}</Link>
      ) : (
        <button key={item.label} onClick={() => onNavigate(item.section)} className={cls} data-testid={testId}>{item.label}</button>
      );
    })}
    <SocialLinks size="xs" idPrefix={mobile ? 'nav-mobile' : 'nav'} className={mobile ? 'justify-start gap-3' : 'gap-2'} />
    <a href={`tel:${companyInfo.phone}`} data-testid={`nav-${mobile ? 'mobile-' : ''}call-now`}>
      <Button className={mobile ? 'w-full bg-yellow-400 text-black font-bold' : 'bg-yellow-400 hover:bg-yellow-500 text-black font-bold shadow-lg'}>
        <Phone className="w-4 h-4 mr-2" />
        Call Now
      </Button>
    </a>
  </>
);

export const SiteHeader = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [tickerOpen, setTickerOpen] = useState(true);
  const navigate = (section) => {
    scrollToSection(section);
    setMobileMenuOpen(false);
  };

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-white/95 backdrop-blur-sm border-b border-gray-200 shadow-sm">
      {tickerOpen && <ChristmasTicker onClose={() => setTickerOpen(false)} />}
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          <div className="flex items-center space-x-2">
            <img src="https://customer-assets.emergentagent.com/job_jetco-electrical/artifacts/x1j92naa_Untitled%20design.png" alt="Jetco Electrical" className="h-12 w-auto" />
          </div>
          <nav className="hidden md:flex items-center space-x-8">
            <NavLinks onNavigate={navigate} />
          </nav>
          <button onClick={() => setMobileMenuOpen((open) => !open)} className="md:hidden p-2 text-gray-700" data-testid="mobile-menu-toggle" aria-label="Toggle menu">
            {mobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>
        {mobileMenuOpen && (
          <div className="md:hidden py-4 border-t border-gray-200">
            <nav className="flex flex-col space-y-4">
              <NavLinks mobile onNavigate={navigate} />
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};
